var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-menu row"},_vm._l((_vm.menu),function(item,index){return _c('div',{key:index,staticClass:"home-menu-item link-content"},[_c('a',{attrs:{"href":item.url}},[_vm._v(_vm._s(item.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }